export const ROOT_PATHS = {
    home: '',
};

export const AUTHENTICATION_PATHS = {
    base: 'auth',
    logIn: 'login'
};

export const ERROR_PATHS = {
    base: 'error',
    notFound: '404',
};

export const DETAIL_PATHS = {
    base: 'detail',
};

export const SUCCESS_PATHS = {
    base: 'success',
};

export const CHECKOUT_PATHS = {
    base: 'checkout',
};

export const CART_PATHS = {
    base: 'cart',
};
